<template>
  <div style="background: #F8F8F7;overflow: hidden;">
    <!-- <el-scrollbar height="100%"> -->
    <div class="menu">
      <div class="menu-text">カメラ</div>
    </div>
    <el-button class="normal-menu normal-menu-color menu-button" :class="this.$route.path === '/' ? 'is-active' : ''"
      color="#EEEEEC" @click="menuChange('ライブビュー')">ライブビュー</el-button>
    <el-button class="normal-menu normal-menu-color menu-button"
      :class="this.$route.path === '/recview' ? 'is-active' : ''" color="#EEEEEC" @click="menuChange('再生')">再生</el-button>
    <div class="menu">
      <div class="menu-text">データ</div>
    </div>
    <el-button class="normal-menu menu-button"
      :class="{ 'is-active': this.$route.path === '/cowmanageview', 'normal-menu-color': !this.isUserTypeDisabled }"
      :disabled="isUserTypeDisabled" color="#EEEEEC" @click="menuChange('牛管理')">牛管理</el-button>
    <el-button class="normal-menu menu-button"
      :class="{ 'is-active': this.$route.path === '/barnmanageview', 'normal-menu-color': !this.isUserTypeDisabled }"
      :disabled="isUserTypeDisabled" color="#EEEEEC" @click="menuChange('牛房管理')">牛房管理</el-button>
    <el-button class="normal-menu normal-menu-color menu-button"
      :class="this.$route.path === '/eventview' ? 'is-active' : ''" color="#EEEEEC"
      @click="menuChange('イベント')">イベント</el-button>
    <el-button v-if="isAdmin" class="normal-menu normal-menu-color menu-button"
      :class="this.$route.path === '/usermanageview' ? 'is-active' : ''" color="#EEEEEC"
      @click="menuChange('ユーザー管理')">ユーザー管理</el-button>
    <el-button v-if="!settingNow" class="normal-menu menu-button menu-badge" color="#EEEEEC"
      :disabled="isUserTypeDisabled" :class="{ 'normal-menu-color': !this.isUserTypeDisabled }"
      @click="menuChange('餌やり時間')">
      設定
      <el-badge :is-dot="badgeEnable" style="z-index:1; position: absolute; top:5px; right:5px" />
    </el-button>
    <div v-if="settingNow" class="menu-setting">
      <div class="menu-setting-text">設定</div>
    </div>
    <div v-if="settingNow && userType != 2">
      <el-button class="setting-menu menu-button" :class="this.$route.path === '/foodtimesettingview' ? 'is-active' : ''"
        color="#EEEEEC" @click="menuChange('餌やり時間')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">餌やり時間</span>
      </el-button>
      <el-button class="setting-menu menu-button" :class="this.$route.path === '/bullsettingview' ? 'is-active' : ''"
        color="#EEEEEC" @click="menuChange('種雄牛')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">種雄牛</span>
      </el-button>
      <el-button class="setting-menu menu-button" :class="this.$route.path === '/eggsettingview' ? 'is-active' : ''"
        color="#EEEEEC" @click="menuChange('受精卵')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">受精卵</span>
      </el-button>
      <el-button class="setting-menu menu-button"
        :class="this.$route.path === '/pregnancyperiodsettingview' ? 'is-active' : ''" color="#EEEEEC"
        @click="menuChange('妊娠期間')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">妊娠期間</span>
      </el-button>
      <el-button class="setting-menu menu-button menu-badge"
        :class="this.$route.path === '/systemupdateview' ? 'is-active' : ''" color="#EEEEEC"
        @click="menuChange('検知システムアップデート')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">検知システムアップデート</span>
        <el-badge :is-dot="badgeEnable" style="z-index:1; position: absolute; top:5px; right:5px" />
      </el-button>
      <el-button class="setting-menu menu-button"
        :class="this.$route.path === '/passwordchangesettingview' ? 'is-active' : ''" color="#EEEEEC"
        @click="menuChange('パスワード変更')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">パスワード変更</span>
      </el-button>
    </div>
    <el-button v-if="!settingOther" class="normal-menu normal-menu-color menu-button menu-badge" color="#EEEEEC"
      @click="menuChange('プライバシーポリシー')">
      その他
    </el-button>
    <div v-if="settingOther" class="menu-setting">
      <div class="menu-setting-text">その他</div>
    </div>
    <div v-if="settingOther">
      <el-button class="setting-menu menu-button" :class="this.$route.path === '/privacyview' ? 'is-active' : ''"
        color="#EEEEEC" @click="menuChange('プライバシーポリシー')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">個人情報保護について</span>
      </el-button>
      <el-button class="setting-menu menu-button" :class="this.$route.path === '/termsofserviceview' ? 'is-active' : ''"
        color="#EEEEEC" @click="menuChange('利用規約')">
        <el-icon>
          <ArrowRightBold />
        </el-icon>
        <span class="setting-menu-text">利用規約</span>
      </el-button>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
import AWSAPI from '../views/js/aws-api';
import ConstParam from '../views/js/const';
import { getCurrentUser, signout } from '../views/js/cognito';

export default {
  props: ['isAdmin', 'userType', 'farmerId', 'setDlsData'],
  data() {
    return {
      isUserTypeDisabled: true,
      userTypeMessage: ConstParam.usertype_message,
      save_user_type: -1,
      badgeEnable: false,
      activeIndex: "",
      cowMenuRadio: "",
      cow_menu_radio: "",
      settingNow: false,
      settingOther: false,
      dlsData: []
    }
  },
  mounted() {
    this.activeIndex = this.$route.name
    this.restore_param()
    this.checkUserType()
    if (this.cow_menu_radio !== '') {
      // 選択済みメニュー値が設定済みの場合はメニュー選択のためボタン表示を合わせる
      this.cowMenuRadio = this.cow_menu_radio
      this.cow_menu_radio = ""
    } else {
      this.cowMenuRadio = "ライブビュー"
    }
    // 現在設定メニューにある画面にいるかどうか
    const settingPathList = [
      '/foodtimesettingview',
      '/bullsettingview',
      '/eggsettingview',
      '/pregnancyperiodsettingview',
      '/systemupdateview',
      '/passwordchangesettingview',
    ]
    this.settingNow = settingPathList.includes(this.$route.path)
    const settingOtherPathList = [
      '/privacyview',
      '/termsofserviceview'
    ]
    this.settingOther = settingOtherPathList.includes(this.$route.path)
  },
  methods: {
    checkUserType() {
      this.isUserTypeDisabled = true
      if (this.userType < ConstParam.disable_user_kind) {
        this.isUserTypeDisabled = false
      }
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    getDls: async function () {
      await AWSAPI.getFarmerDls(this.farmerId)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.dlsData = res['data']['data'];
          }
        });
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    menuChange(cowMenu) {
      // パラメータ保存
      this.$store.commit('setCowMenuSelect', cowMenu);
      if (cowMenu !== this.cow_menu_radio) {
        // ページ遷移
        if (cowMenu === 'ライブビュー') {
          this.$router.push('/');
        } else if (cowMenu === '再生') {
          this.$router.push('/recview');
        } else if (cowMenu === '牛管理') {
          this.$router.push('/cowmanageview');
        } else if (cowMenu === '牛房管理') {
          this.$router.push('/barnmanageview');
        } else if (cowMenu === 'イベント') {
          this.$router.push('/eventview');
        } else if (cowMenu === '設定') {
          this.$router.push('/foodtimesettingview');
        } else if (cowMenu === 'ユーザー管理') {
          this.$router.push('/usermanageview');
        } else if (cowMenu === '餌やり時間' || cowMenu === '> 餌やり時間') {
          this.$router.push('/foodtimesettingview');
        } else if (cowMenu === '種雄牛' || cowMenu === '> 種雄牛') {
          this.$router.push('/bullsettingview');
        } else if (cowMenu === '受精卵' || cowMenu === '> 受精卵') {
          this.$router.push('/eggsettingview');
        } else if (cowMenu === '妊娠期間' || cowMenu === '> 妊娠期間') {
          this.$router.push('/pregnancyperiodsettingview');
        } else if (cowMenu === '検知システムアップデート' || cowMenu === '> 検知システムアップデート') {
          this.$router.push('/systemupdateview');
        } else if (cowMenu === 'パスワード変更' || cowMenu === '> パスワード変更') {
          this.$router.push('/passwordchangesettingview');
        } else if (cowMenu === 'プライバシーポリシー' || cowMenu === '> プライバシーポリシー') {
          this.$router.push('/privacyview');
        } else if (cowMenu === '利用規約' || cowMenu === '> 利用規約') {
          this.$router.push('/termsofserviceview');
        }
        this.cow_menu_radio = cowMenu;
      }
    },
    restore_param() {
      // パラメータ復元
      this.cow_menu_radio = this.$store.state.cowMenuSelect;
      this.save_user_type = this.$store.state.userType;
    }
  },
  watch: {
    userType: function () {
      this.checkUserType()
      if (
        this.save_user_type != -1 &&
        this.save_user_type != this.userType) {
        this.alertMessage("通知", this.userTypeMessage)
        this.click_user_signout()
      }
      // パラメータ保存(権限)
      this.$store.commit('setUserType', this.userType)
    },
    farmerId: function () {
      if (this.farmerId !== "") {
        this.getDls();
      }
    },
    setDlsData: function () {
      this.dlsData = this.setDlsData;
    },
    dlsData: function () {
      this.badgeEnable = false;
      for (let idx = 0; idx < this.dlsData.length; idx++) {
        let tempSoftwareUpdateReady = false;
        if ("software_update_ready" in this.dlsData[idx]) {
          tempSoftwareUpdateReady = this.dlsData[idx].software_update_ready;
        }
        if (tempSoftwareUpdateReady) {
          // アップデート可能
          this.badgeEnable = true;
        }
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.menu {
  width: 100%;
  /* height: 42px; */
  height: 36px;
  color: #383838;
  border-bottom: 1px solid #C3C2C1;
}

.menu-text {
  /* padding: 10px 24px; */
  padding: 7px 24px;
  font-size: 14px;
  line-height: 22px;
}

.menu-setting {
  width: 100%;
  /* height: 60px; */
  height: 48px;
  background: #EEEEEC;
  border-bottom: 1px solid #C3C2C1;
}

.menu-setting-sub {
  width: 100%;
  height: 30px;
  /* background: #EEEEEC; */
  border-bottom: 1px solid #C3C2C1;
}

.menu-setting-text {
  /* padding: 17px 44px; */
  padding: 11px 44px;
  font-size: 18px;
  line-height: 26px;
}

.menu-setting-sub-text {
  padding: 5px 44px;
  font-size: 14px;
  line-height: 22px;
}

.setting-menu-text {
  margin-left: 8px;
}

:deep(.el-button) {
  border-left: none !important;
  border-radius: 0 !important;
}

:deep(.is-active) {
  background: #dadad8 !important;
  border-radius: 0 !important;
}

.normal-menu {
  padding: 11px 44px;
  width: 100%;
  text-align: start;
  border: none;
  border-bottom: 1px solid #C3C2C1;
  box-shadow: none !important;
  font-size: 18px;
  line-height: 26px;
  height: 49px;
}

.normal-menu-color {
  /* background: #EEEEEC; */
  color: #383838;
}

.setting-menu {
  padding: 10px 24px 10px 44px;
  background: #EEEEEC;
  width: 100%;
  text-align: start;
  border: none;
  border-bottom: 1px solid #C3C2C1;
  box-shadow: none !important;
  color: #383838;
  font-size: 14px;
  line-height: 22px;
  height: 36px;
}

.menu-button {
  margin-left: 1px !important;
  /* height: 60px; */
  justify-content: left !important;
}

.el-button:focus {
  outline: 0;
  border-top: 2px solid var(--el-color-primary);
  border-bottom: 2px solid var(--el-color-primary);
}

/* ホバー時の背景色・文字色*/
.el-button.is-active:hover {
  color: rgba(56, 56, 56, 0.6) !important;
  background: #EEEEEC !important;
}

.normal-menu :deep(.el-button:hover) {
  color: rgba(56, 56, 56, 0.6) !important;
  background: #EEEEEC !important;
}

.setting-menu :deep(.el-button:hover) {
  color: rgba(56, 56, 56, 0.6) !important;
  background: #EEEEEC !important;
}

.menu-badge {
  position: relative;
}
</style>